/* paletteNav — overlay-safe navigace z command palette / globálního hledání.
 *
 * PROČ: Klientská složka je overlay (ClientFolderHost, fixed z-78) s vlastním
 * tab systémem (GlobalTabBar). Samotný react-router `navigate(path)` cílovou
 * stránku sice namountuje, ale overlay o změně routy neví → zůstane viset NAD ní
 * a uživateli to připadá, že palette „nefunguje" z otevřené složky.
 *
 * ŘEŠENÍ: převzít ověřený vzor z LeftSidebar.onSectionClick — NEJDŘÍV zavřít
 * všechny otevřené složky (`close-all-client-folders`), TEPRVE POTOM navigovat.
 * Event je bezpečný i když žádná složka otevřená není (no-op v ClientFolderHost
 * i GlobalTabBar), takže se dá volat vždy před navigací na sekci/nástroj/stránku.
 *
 * Kdo event poslouchá:
 *   • ClientFolderHost      → zavře overlay (setActiveId(null), vyčistí cache)
 *   • GlobalTabBar          → odebere klientské záložky, aktivní přehodí na sekci
 * Žádný z listenerů sám nenaviguje → nevzniká dvojitá navigace.
 */
export function navigateOverlaySafe(navigate, path) {
  if (!path) return; // prázdný cíl → nic (nezavírej složku zbytečně, nenaviguj)
  if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
    window.dispatchEvent(new CustomEvent("close-all-client-folders"));
  }
  if (typeof navigate === "function") navigate(path);
}
